import { render, staticRenderFns } from "./Measure.vue?vue&type=template&id=2f800fb2&scoped=true&"
import script from "./Measure.vue?vue&type=script&lang=js&"
export * from "./Measure.vue?vue&type=script&lang=js&"
import style0 from "./Measure.vue?vue&type=style&index=0&id=2f800fb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f800fb2",
  null
  
)

component.options.__file = "Measure.vue"
export default component.exports